import { noteSchema } from 'constants/note-schemas';
import { useEffect } from 'react';
import { noteSchemaTransitionsByAppointmentStatus, noteSchemaTransitionsByNoteType, useNoteSchemaContext, } from '../contexts';
export var useNoteSchemaTransitions = function () {
    var _a = useNoteSchemaContext(), form = _a.form, schema = _a.schema, noteType = _a.noteType, send = _a.send;
    useEffect(function () {
        var subscription = form.watch(function (value, _a) {
            var _b, _c;
            var name = _a.name;
            // If note type changes and we are not currently showing no-show note, swap to the schema for that note type
            if (((_b = value.sessionInfo) === null || _b === void 0 ? void 0 : _b.noteType) &&
                schema !== noteSchema.notAttended &&
                name === 'sessionInfo.noteType') {
                send(noteSchemaTransitionsByNoteType[value.sessionInfo.noteType]);
            }
            if (((_c = value.sessionInfo) === null || _c === void 0 ? void 0 : _c.status) && name === 'sessionInfo.status') {
                send(noteSchemaTransitionsByAppointmentStatus[value.sessionInfo.status]);
            }
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [noteType, schema, form]);
};
